module.exports = __webpack_public_path__ + "assets/img/kv-d5aca51a.jpg";